import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom'; // For navigation to individual blog posts

const BlogWrapper = styled.section`
  padding: 50px 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const BlogTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 40px;
  text-align: center;
  color: #0070c9;
`;

const LatestBlogWrapper = styled.div`
  display: flex;
  margin-bottom: 50px;
  background-color: #f9f9f9;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
`;

const LatestBlogImage = styled.div`
  flex: 1;
  background: url('/path-to-latest-blog-image.jpg') no-repeat center center/cover;
  min-height: 300px;
`;

const LatestBlogContent = styled.div`
  flex: 2;
  padding: 30px;
`;

const PostDate = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 10px;
`;

const LatestPostTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 20px;
  color: #333;
`;

const PostExcerpt = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 20px;
`;

const ReadMoreLink = styled(Link)`
  color: #0070c9;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const PostGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
`;

const BlogPostCard = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }
`;

const BlogPostTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #333;
`;

const BlogPostExcerpt = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #666;
`;

const BlogPostDate = styled.p`
  font-size: 0.9rem;
  color: #888;
  margin-bottom: 10px;
`;

const Blog = () => {
  const latestPost = {
    title: 'FinOps Explained: Beyond Traditional Cost Management',
    excerpt: 'When people think of what FinOps is, they often associate it solely with cost optimization and reducing cloud expenditure...',
    date: '02 Sep 2024',
    author: 'Kelly Griffin',
    route: '/blog/finops-explained',
    image: '/path-to-finops-image.jpg', // Replace with your image path
  };

  const otherPosts = [
    {
      title: 'Ensuring Security and Efficiency in Release',
      excerpt: 'Security is paramount in every release cycle. Here are five key strategies to ensure your next release is both secure and efficient...',
      date: '25 Aug 2024',
      route: '/blog/security-and-efficiency',
    },
    {
      title: 'Leveraging AWS Capabilities Post VMware Migration',
      excerpt: 'Learn how to fully leverage AWS capabilities after migrating from VMware to enhance your infrastructure...',
      date: '14 Aug 2024',
      route: '/blog/aws-vmware-migration',
    },
    {
      title: 'AWS RDS Blue/Green Deployment: A Safe Path to New Releases',
      excerpt: 'Discover how AWS RDS Blue/Green deployment can safely streamline your release process...',
      date: '08 Aug 2024',
      route: '/blog/aws-rds-deployment',
    },
    {
      title: 'AI-Driven Insights for Your Business Growth',
      excerpt: 'AI is reshaping how businesses operate. Here’s how AI-driven insights can drive your growth strategy...',
      date: '30 Jul 2024',
      route: '/blog/ai-driven-insights',
    }
  ];

  return (
    <BlogWrapper>
      <BlogTitle>Blog</BlogTitle>

      {/* Latest Blog Post */}
      <LatestBlogWrapper>
        <LatestBlogImage />
        <LatestBlogContent>
          <PostDate>{latestPost.date}</PostDate>
          <LatestPostTitle>{latestPost.title}</LatestPostTitle>
          <PostExcerpt>{latestPost.excerpt}</PostExcerpt>
          <ReadMoreLink to={latestPost.route}>Continue Reading</ReadMoreLink>
        </LatestBlogContent>
      </LatestBlogWrapper>

      {/* Other Blog Posts Grid */}
      <PostGrid>
        {otherPosts.map((post, index) => (
          <BlogPostCard key={index}>
            <BlogPostDate>{post.date}</BlogPostDate>
            <BlogPostTitle>{post.title}</BlogPostTitle>
            <BlogPostExcerpt>{post.excerpt}</BlogPostExcerpt>
            <ReadMoreLink to={post.route}>Continue Reading</ReadMoreLink>
          </BlogPostCard>
        ))}
      </PostGrid>
    </BlogWrapper>
  );
};

export default Blog;
